const IframeDialogComponentStyles = () => ({
    header: {
        fontSize: '1.2rem',
        color: 'white',
    },
    dialog: {
        overflow: 'visible',
    },
    paper: {
        overflow: 'visible',
    },
    title: {
        fontSize: '1.3rem',
        fontWeight: '400',
        padding: '1rem',
        backgroundColor: '#1E3A8A',
    },
    dialogContent: {
        minWidth: '768px',
        overflow: 'visible',
        padding: 0.5,
    },
    closeIcon: {
        color: 'white',
    },
});

export default IframeDialogComponentStyles;
